/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMessageReply = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15.008 13.481a.522.522 0 0 0-.021-.144c-.092-5.103-5.063-8.351-8.495-8.351h-1.8l1.153-1.151a.5.5 0 0 0-.706-.708l-4 3.994a.501.501 0 0 0-.001.707l4 4.007a.504.504 0 0 0 .707 0 .5.5 0 0 0 .001-.708L4.709 9.988c.093.002.196.003.317.003.507 0 1.233-.011 1.466-.015 3.652 0 6.128 1.228 7.57 3.751.09.157.256.249.43.249h.012c.265-.016.504-.219.504-.495z"
    />
  </svg>
);

IconMessageReply.displayName = 'IconMessageReply';

IconMessageReply.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMessageReply);
IconMessageReply.displayName = 'IconMessageReply';
